// extracted by mini-css-extract-plugin
module.exports = {"container":"myInvest_container__RlajB","splitLine":"myInvest_splitLine__BndLN"};